<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="制单人">
                                <el-input style="width: 180px" v-model="makeBy" placeholder="双击选择制单人" @click.native="selUser">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="项目名称">
                                <el-input style="width: 180px" v-model="projectName" placeholder="双击选择项目名称" @click.native="selProject">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="供应商">
                                <el-input style="width: 180px" v-model="supplierName" placeholder="双击选择供应商" @click.native="selSupplier">
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="物资编码">
                                <el-input style="width: 180px" v-model="proCode" placeholder="输入物资编码" >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="物资名称">
                                <el-input style="width: 180px" v-model="proName" placeholder="输入物资名称" >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="账单日期">
                                <el-date-picker
                                        v-model="billDate"
                                        size="medium"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>

        <selUser v-if="showUser"
                      :roleData="makeBy"
                      @closeDialog="closeDialog"
                      @checkRow="checkUser">
        </selUser>
        <selSupplier v-if="showSupplier"
                     :supplierId="supplierId"
                     @closeDialog="closeDialog"
                     @checkRow="checkSupplier">
        </selSupplier>
        <selProject v-if="showProject"
                    :projectId="projectId"
                    @closeDialog="closeDialog"
                    @checkRow="checkProject">
        </selProject>
    </div>
</template>

<script>
    import selUser from '@/components/system/usermanage/userSelect/single'
    import selSupplier from '@/components/page/supplier/supplier/selSupplier'
    import selProject from '@/components/page/project/selProject'


    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            selUser,selSupplier,selProject
        },
        data() {
            return {
                searBarHeight: 70,

                makeBy:"",
                showUser:false,
                showSupplier:false,
                showProject:false,

                billNo:"",
                billDate:[],
                projectId:"",
                projectName:"",
                proCode:"",
                proName:"",
                reviewState:"",
                supplierId:"",
                supplierName:"",
            }
        },
        methods: {
            selUser(){
                this.showUser = true;
            },
            closeDialog() {
                this.showUser = false;
                this.showSupplier =false;
                this.showProject = false;
            },
            checkUser(row) {
                this.makeBy = row.loginName;
                this.showUser = false;
            },
            selSupplier(){
                this.showSupplier = true;
            },
            checkSupplier(row) {
                this.supplierId = row.supplierId;
                this.supplierName = row.supplierName;
                this.showSupplier = false;
            },
            selProject() {
                this.showProject = true;
            },
            checkProject(row) {
                this.projectId = row.projectId;
                this.projectName = row.projectName;
                this.showProject = false;
            },
            search() {

                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    billNo:this.billNo,
                    projectName:this.projectName,
                    proCode:this.proCode,
                    proName:this.proName,
                    makeBy:this.makeBy,
                    supplierName:this.supplierName,
                }
                this.$emit('search',searchData);
            },
            excel() {
                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    billNo:this.billNo,
                    projectName:this.projectName,
                    proCode:this.proCode,
                    proName:this.proName,
                    makeBy:this.makeBy,
                    supplierName:this.supplierName,
                }
                this.$emit('excel',searchData);
            },
        }
    }
</script>

